import dayjs from "dayjs";

// Helpers de extracción/formato sobre el shape del endpoint de carrera.

export const isEmpty = (v) => v === undefined || v === null || v === "";

export const metricValue = (data, metric) => data?.find((d) => d?.METRIC === metric)?.METRIC_VALUE;
export const metricEntry = (data, metric) => data?.find((d) => d?.METRIC === metric);
export const bySource = (data, source) => (data || []).filter((d) => d?.source === source);

// Algunas métricas (p.ej. TURNOVER_VOLUNTARY_YTD) vienen repetidas con distinta
// fecha; tomamos la más reciente por TIM_DATE (o por YEAR como respaldo).
const parseDate = (s) => {
  if (isEmpty(s)) return 0;
  const ts = Date.parse(s);
  return Number.isNaN(ts) ? 0 : ts;
};
export const latestMetricValue = (data, metric) => {
  const items = (data || []).filter((d) => d?.METRIC === metric);
  if (!items.length) return undefined;
  return items
    .slice()
    .sort((a, b) => (parseDate(b?.TIM_DATE) - parseDate(a?.TIM_DATE)) || ((b?.YEAR || 0) - (a?.YEAR || 0)))[0]
    ?.METRIC_VALUE;
};

// Formatea fechas (acepta ISO "2025-03-01" y GMT "Thu, 19 Mar 2026 00:00:00 GMT").
export const fmtDate = (v) => {
  if (isEmpty(v)) return "";
  const d = dayjs(new Date(v));
  return d.isValid() ? d.format("DD/MM/YYYY") : v;
};

// Une varios valores no vacíos en un solo texto (para campos "merge").
export const mergeNonEmpty = (values, separator = " · ") =>
  (values || []).filter((x) => !isEmpty(x)).join(separator);
